'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/analysis-chart-tooltip-template.html'));
var AnalysisChartController = function AnalysisChartController($scope, $filter, $timeout, dataProviderService, seasonalityOverridesService, formatter, seasonColorService, seasonalityConstants, featureToggleService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.displayedCalendar.visibleData = 'historical';
  $scope.cogChannel = 'analysis-chart';
  $scope.cogOptions = require('../config/cogOptions.json');
  $scope.analysisContextMenuItems = [];
  $scope.cabinList = dataProviderService.getCabins($scope.displayedCalendar.market);
  $scope.contextMenuChanged = false;
  $scope.displayedCalendar.seasonalityType = $scope.seasonalityType;
  $scope.isDASeasonality = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY');
  $scope.dowGroupLabel = $scope.isDASeasonality ? 'DOW ' : 'DOW Group ';
  if ($scope.isDASeasonality) {
    $scope.displayedCalendar.cabin = _.first($scope.cabinList);
  }
  $scope.initChart = function () {
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.updateChart = function () {
    redrawChart();
  };
  $scope.$watchGroup(['displayedCalendar.calendarName', 'displayedCalendar.spos', 'displayedCalendar.classGroup', 'displayedCalendar.market', 'displayedCalendar.selectedDow', 'displayedCalendar.visibleData', 'displayedCalendar.cabin', 'displayedCalendar.flowType'], $scope.updateChart);
  $scope.$on('cog:analysis-chart', function (event, cogOption) {
    $scope.displayedCalendar.visibleData = cogOption.val[0];
    $scope.$broadcast('context-menu:close');
  });
  function getSearchParams(calendar) {
    var searchParams = {
      calendarName: calendar.calendarName,
      market: calendar.market,
      visibleData: calendar.visibleData,
      startDate: calendar.startDepartureDate,
      endDate: calendar.endDepartureDate,
      spos: calendar.spos,
      dowGroup: _.get(calendar, 'selectedDow.id', [undefined]),
      overrides: calendar.overrides,
      seasonalityType: $scope.seasonalityType
    };
    if ($scope.seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED) {
      searchParams.cabin = calendar.cabin;
      searchParams.calendarEntryStatus = calendar.calendarEntryStatus;
      searchParams.maxRtp = calendar.maxRtp;
      searchParams.flowType = calendar.flowType;
    } else if ($scope.isDASeasonality) {
      searchParams.cabin = calendar.cabin;
      searchParams.classGroup = calendar.classGroup;
      searchParams.isDASeasonality = $scope.isDASeasonality;
    } else {
      searchParams.classGroup = calendar.classGroup;
    }
    return searchParams;
  }
  function redrawChart(skipInit) {
    var searchParams = getSearchParams($scope.displayedCalendar);
    if (!searchParams.dowGroup) {
      return;
    }
    dataProviderService.getData(searchParams).then(function (chartData) {
      $scope.data = chartData.data;
      $scope.legend = chartData.legend;
      $scope.renderChart(chartData.data);
      if (!skipInit && _.isArray($scope.data) && $scope.data.length) {
        $scope.analysisContextMenuItems = seasonColorService.getSortedSeasonMenu(chartData.legend);
        $scope.setInitialSelection([0, $scope.data.length]);
      }
    });
  }
  $scope.updateOverrideData = function (selection, selectedContext) {
    if (!selection.length) {
      return false;
    }
    for (var i = selection[0]; i < selection[1]; i++) {
      $scope.displayedCalendar.overrides = seasonalityOverridesService.addOverride($scope.displayedCalendar, $scope.data[i].weekNumber, selectedContext.season);
    }
    redrawChart(true);
    $scope.contextMenuChanged = true;
    $scope.$emit('seasonality-analysis:override-data-change', $scope.displayedCalendar.overrides);
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: formatter.identity,
    yAxisTickFormatter: formatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        season: _.capitalize(d.season),
        average: d.average !== undefined ? rmNumberFormat(d.average, 'NUMBER') : undefined,
        isPooledSeasonality: d.isPooledSeasonality,
        resholdValue: rmNumberFormat(d.m1, 'NUMBER')
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'analysis-chart-tooltip';
  $scope.updateContextMenu = function (selectedBars) {
    $timeout(function () {
      $scope.analysisContextMenuItems.forEach(function (menu) {
        var seasonFromSelection = _.find(selectedBars, {
          season: menu.season
        });
        menu.active = !_.isUndefined(seasonFromSelection);
      });
    }, 10);
  };
  $scope.pooledSeasonalityType = function () {
    return $scope.seasonalityType === 'pooled_seasonality';
  };
  $scope.publishCalendar = function () {
    $scope.$emit('pooled-seasonality:publish-profile-request');
  };
  $scope.isPublishButtonDisabled = function () {
    var status = $scope.displayedCalendar.calendarEntryStatus;
    return status === seasonalityConstants.CALENDAR_STATUSES.RUNNING || status === seasonalityConstants.CALENDAR_STATUSES.PUBLISHED || status === seasonalityConstants.CALENDAR_STATUSES.INACTIVE;
  };
  $scope.isSaveButtonDisabled = function () {
    var status = $scope.displayedCalendar.calendarEntryStatus;
    if (status === seasonalityConstants.CALENDAR_STATUSES.RUNNING || status === seasonalityConstants.CALENDAR_STATUSES.INACTIVE) {
      return true;
    }
    return !$scope.contextMenuChanged;
  };
  $scope.saveOverrides = function () {
    $scope.$emit('pooled-seasonality:save-events-and-overrides');
    if ($scope.displayedCalendar.calendarEntryStatus === seasonalityConstants.CALENDAR_STATUSES.PUBLISHED) {
      $scope.displayedCalendar.calendarEntryStatus = seasonalityConstants.CALENDAR_STATUSES.RUNNING;
    }
    $scope.contextMenuChanged = false;
  };
};
AnalysisChartController.$inject = ['$scope', '$filter', '$timeout', 'AnalysisChartDataProviderService', 'SeasonalityOverridesService', 'FormatterService', 'SeasonColorService', 'SeasonalityConstants', 'FeatureToggleService'];
module.exports = AnalysisChartController;